var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id ? _vm.$t("modify") : _vm.$t("add"),
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            },
            close: function($event) {
              return _vm.resetForm("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "env_name", label: _vm.$t("environmentName") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.env_name,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "env_name", $$v)
                      },
                      expression: "paramsData.env_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "env_flag", label: _vm.$t("environmentMark") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.env_flag,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "env_flag", $$v)
                      },
                      expression: "paramsData.env_flag"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "env_gm_url", label: _vm.$t("gmUrl") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.env_gm_url,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "env_gm_url", $$v)
                      },
                      expression: "paramsData.env_gm_url"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "game_ids", label: _vm.$t("gameList") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectGame")
                      },
                      model: {
                        value: _vm.paramsData.game_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "game_ids", $$v)
                        },
                        expression: "paramsData.game_ids"
                      }
                    },
                    _vm._l(_vm.gameList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.game_name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "pass_key", label: _vm.$t("secretKey") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.pass_key,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "pass_key", $$v)
                      },
                      expression: "paramsData.pass_key"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }